<template>
  <a @click="routerPage(music)" class="content-card-tasks">
    <div class="content-card-tasks--bg" :style="{ background: `url(data:image/jpg;base64,${music.picture})` }">
    </div>
    <div class="content-card-tasks-div">
      <div class="content-card-tasks--description">
        <img class="img-fluid" src="@/assets/img/notas-musicais.png" alt="icon music" title="icon music"/>
        <h2>{{ music.name }}</h2>
      </div>
      <div class="content-card-tasks--text">
        <div class="icon">
          <img class="img-fluid" src="@/assets/img/despertador.png" alt="icon clock" title="icon clock"/>
          <p>Tempo:</p>
        </div>
        <p>{{ music.music_time | formatTime }}</p>
      </div>
    </div>
    <div class="content-card-tasks--plans">
      <div class="content--name">
        <p>{{ music.music_name }}</p>
      </div>
    </div>
  </a>
</template>

<script>

export default {
  props: ['music'],
  methods: {
    routerPage(music) {
      this.$router.push({
        name: 'EditMusic',
        params: {
          id: music.id
        },
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.content-card-tasks {
  display: flex;
  flex-direction: column;
  background: var(--white);
  box-shadow: 0px 1px 3px rgba(0,0,0,0.25);
  border-radius: 10px;
  padding: 15px;
  margin-bottom: 30px;
  min-height: 267px;
  transition: 500ms;
  &:hover,&:focus {
    cursor: pointer;
    opacity: 0.8;
  }
  &--bg {
    display: block;
    width: 128px;
    height: 128px;
    background-position: center !important;
    background-repeat: no-repeat !important;
    border: 1px solid var(--gray-);
    border-radius: 100%;
    box-shadow: 0px 3px 6px rgba(0,0,0,0.16);
    margin: 0 auto 15px auto;
  }
  &-div {
    padding: 15px 0px;
    border-top: 1px solid rgba(0,0,0,0.05);
  }
  &--description {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;
    img {
      max-width: 25px;
      margin-right: 10px;
    }
    h2 {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      font-family: 'Font Semibold';
      color: var(--black);
      text-align: left;
      margin-bottom: 0px;
      @media (min-width: 577px){
        height: 25px;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
    }
    p {
      font-size: 16px;
      font-family: 'Font Light';
      color: var(--black);
      text-align: center;
      margin-bottom: 0;
      @media (min-width: 577px){
        height: 120px;
        display: -webkit-box;
        -webkit-line-clamp: 5;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
    }
  }
  &--details {
    display: flex;
    flex-wrap: wrap;
    padding: 5px 0px;
    max-width: 250px;
    margin: 0 auto;
    .content--elements {
      width: 50%;
      padding: 5px 0px;
      display: flex;
      align-items: center;
      img {
        margin-right: 5px;
      }
      p {
        font-size: 14px;
        font-family: 'Font Semibold';
        color: var(--black);
        width: 80px;
        text-align: left;
        margin-bottom: 0;
      }
    }
  }
  &--plans {
    padding-top: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    border-top: 1px solid rgba(0,0,0,0.05);
    .content--title {
      display: flex;
      align-items: center;
      margin-right: 5px;
      img {
        max-width: 15px;
        margin-right: 5px;
      }
      p {
        font-size: 14px;
        font-family: 'Font Semibold';
        color: var(--black);
        margin-bottom: 0;
      }
    }
    .content--name {
      p {
        font-size: 12px;
        font-family: 'Font Light';
        color: var(--black);
        word-break: break-all;
        margin-bottom: 0;
      }
    }
  }
  &--text {
    display: flex;
    align-items: center;
    justify-content: center;
    .icon {
      display: flex;
      align-items: center;
      margin-right: 10px;
      p {
        font-size: 14px;
        font-family: 'Font Semibold';
        color: var(--black);
        margin-bottom: 0;
      }
      img {
        max-width: 15px;
        margin-right: 5px;
      }
    }
    p {
      font-size: 14px;
      font-family: 'Font Light';
      color: var(--black);
      margin-bottom: 0;
    }
  }
}
</style>
